<template>
    <div>
        <a-select v-model="currentSys" style="width: 150px" show-search @change="handleSelectChange">
            <a-select-option v-for="item in sysList" :key="item.key" :value="item.key">
                {{item.name}}
            </a-select-option>
            
        </a-select>
    </div>
</template>

<script>
const sysList = [
    {
        key:'cloudpos_h5',
        name:'老版收银机'
    },
    {
        key:'stablepos_h5',
        name:'收银机 3.0'
    },
    {
        key:'stablepos_subscreen',
        name:'收银机 3.0 副屏'
    },
    {
        key:'stableposv5_h5',
        name:'收银机 5.0'
    },
    {
        key:'POSASSISTANT_APP-001',
        name:'银响力APP'
    },
    {
        key:'cashapp',
        name:'中仑掌柜'
    },
    {
        key:'yxl_web',
        name:'银响力后台'
    },
    {
        key:'f',
        name:'磐石平台'
    },
]
export default {
    model:{
        prop:'selectedWebSys',
        event:'change'
    },
    props:{
        selectedWebSys:String
    },
    data(){
        return {
            sysList,
            currentSys:'',
            cacheKey: 'monitorweb_current_sysname_s'
        }
    },
    methods:{
        handleSelectChange(v){
            this.currentSys = v;
            localStorage.setItem(this.cacheKey,v);
            this.$emit('change',v)
        },
        getCurrentSys(defaultSysName){
            let cachedSys = localStorage.getItem(this.cacheKey);
            let targetItem = this.sysList.filter((n) => { return n.key == cachedSys });
            let result = 'fp'
            if(defaultSysName){
                if(this.sysList.filter((n) => { return n.key == defaultSysName }).length > 0){
                    result = defaultSysName
                }
            }
            else if(cachedSys && targetItem.length > 0){
                result = cachedSys;
            }
            localStorage.setItem(this.cacheKey,result);
            return result
        }
    },
    mounted(){
        const {query} = this.$route;
        let default_sys = ''
        if(query.qs){
            default_sys = query.qs
        }
        this.currentSys = this.getCurrentSys(default_sys);
        this.$emit('change',this.currentSys)
    },

    components:{

    }
};
</script>

<style lang="less" scoped>
</style>
